import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import './WelcomePopup.css';

const WelcomePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // Check if popup was already closed in this session
    const popupClosed = sessionStorage.getItem('clickfish-welcome-popup-closed');
    
    if (!popupClosed) {
      // Small delay for smooth entrance
      const timer = setTimeout(() => {
        setShouldShow(true);
        // Prevent body scroll when popup is open
        document.body.classList.add('popup-open');
        // Trigger fade-in animation
        setTimeout(() => setIsVisible(true), 50);
      }, 500);

      return () => {
        clearTimeout(timer);
        document.body.classList.remove('popup-open');
      };
    }
  }, []);

  useEffect(() => {
    // Cleanup function to remove body class when component unmounts
    return () => {
      document.body.classList.remove('popup-open');
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Allow body scroll when popup is closed
    document.body.classList.remove('popup-open');
    // Store that popup was closed in this session
    sessionStorage.setItem('clickfish-welcome-popup-closed', 'true');
    // Remove popup from DOM after animation
    setTimeout(() => setShouldShow(false), 300);
  };

  const handleShopNow = () => {
    handleClose();
    // Scroll to top of page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!shouldShow) return null;

  return (
    <div 
      className={`welcome-popup-overlay ${isVisible ? 'visible' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className={`welcome-popup-container ${isVisible ? 'visible' : ''}`}>
        {/* Close Button */}
        <button 
          className="welcome-popup-close"
          onClick={handleClose}
          aria-label="إغلاق النافذة"
        >
          <FaTimes />
        </button>

        {/* Logo Placeholder */}
        <div className="welcome-popup-logo">
          <div className="logo-placeholder">
            <img 
              src="/logo.png" 
              alt="شعار ClickFish DZ" 
              onError={(e) => {
                e.target.style.display = 'none';
                if (e.target.nextSibling) {
                  e.target.nextSibling.style.display = 'flex';
                }
              }}
            />
            <div className="logo-fallback" style={{ display: 'none' }}>
              🐠 ClickFish DZ
            </div>
          </div>
        </div>

        {/* Marketing Text - Arabic */}
        <div className="welcome-popup-content">
          <h2 className="welcome-popup-title">
            مرحبًا بك في ClickFish DZ
          </h2>
          <p className="welcome-popup-text">
            متجرك الأول للأحواض المائية في الجزائر! اكتشف الأسماك، النباتات، الأحواض، وأعلاف السمك المميزة.
          </p>
        </div>

        {/* CTA Button - Arabic */}
        <button 
          className="welcome-popup-cta"
          onClick={handleShopNow}
        >
          تسوق الآن
        </button>
      </div>
    </div>
  );
};

export default WelcomePopup;
